import { Provider } from '@angular/core';

import { guardProviders } from './guard.providers';
import { modelProviders } from './model.providers';
import { serviceProviders } from './service.providers';
import { authProviders } from './authentication.providers';
import { vendorProviders } from './vendor.providers';
import { MonitoringService } from 'services/monitoring.service';

const bootstrapProviders = [MonitoringService];

export const providers = [
    ...bootstrapProviders,
    ...authProviders,
    ...modelProviders,
    ...serviceProviders,
    ...guardProviders,
    ...vendorProviders
] as Provider[];
